import { CommonModule } from '@angular/common';
import { ErrorHandler, Injectable, Injector, NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ComentariosComponent } from './comentarios/comentarios.component';
import { QuestionarioRoutingModule } from './questionario-routing.module';
import { QuestionarioComponent } from './questionario.component';
import { QuestoesComponent } from './questoes/questoes.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgxHotjarModule, NgxHotjarRouterModule } from 'ngx-hotjar';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService, NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import * as StackTrace from 'stacktrace-js';
import { ComentariosProfessorComponent } from './comentarios-professor/comentarios-professor.component';
import { PageIntrucaoComponent } from './components/page-intrucao/page-intrucao.component';


@Injectable()
class AppGlobalErrorhandler implements ErrorHandler {
    constructor(
        private injector: Injector,
    ) {}

    async handleError(error) {
        try {

            console.error(error);

            const stackTrace2 = await StackTrace.fromError(error, {offline: false});

            console.table(stackTrace2);

            var stringfyStactrace = stackTrace2.map(p => p.fileName?.split("/")[p.fileName?.split("/").length - 1] + "(" + p.lineNumber + "," + p.columnNumber + ")#" + p.functionName)

            var ultimasChamadas = stringfyStactrace.filter((p,idx) => idx < 5)

            console.table(ultimasChamadas)

            var logParaAnalytics = error + " " + ultimasChamadas.join("|")

            console.log(logParaAnalytics)

            let analytics = this.injector.get(GoogleAnalyticsService)

            analytics.event(environment.stage + "_" + window.location.pathname, "poa__error", logParaAnalytics)

        } catch (e) {
            console.error(error);
            console.log(e)
        }
    
    }
  }

@NgModule({
    declarations: [QuestionarioComponent, ComentariosComponent, QuestoesComponent, ComentariosProfessorComponent, PageIntrucaoComponent],
    imports: [
        CommonModule,
        LazyLoadImageModule,
        MatCardModule,
        QuestionarioRoutingModule,
        SharedModule,
        MatCheckboxModule,
        PipesModule,
        NgxHotjarModule.forRoot(environment.hotjar),
        NgxHotjarRouterModule,
        NgxGoogleAnalyticsModule.forRoot(environment.analytics),
        NgxGoogleAnalyticsRouterModule,
    ],
    providers: [    
        {provide: ErrorHandler, useClass: AppGlobalErrorhandler}    
    ],    
})
export class QuestionarioModule {}

